import React, { PureComponent, ReactNode } from "react";
import "./OptionMenuToggle.css";

interface Props<T> {
  optionShortNames: Array<T>;
  selected: T;
  printShortName: (sn: T) => string;
  onChange: (value: T) => void;
}
interface State {}

class OptionMenuToggle<T> extends PureComponent<Props<T>, State> {
  constructor(props: Props<T>) {
    super(props);
    this.state = {};
  }

  curriedSelect = (opt: T) => () => {
    this.props.onChange(opt);
  };

  render(): ReactNode {
    const { optionShortNames, selected, printShortName } = this.props;
    const selectedIndex = optionShortNames.findIndex((o) => o === selected);
    return (
      <div className="open-menu-toggle-wrapper open-menu-one-liner">
        <div className="option-menu-selections">
          {optionShortNames.map((osn, index) => {
            const shortName = printShortName(osn); // Maybe require string mapper func
            const selectedClass = index === selectedIndex ? "selected" : "";
            const className = `option-menu-toggle-shortname ${selectedClass}`;
            return (
              <span key={shortName} className={className}>
                <button onClick={this.curriedSelect(osn)}>{shortName}</button>
              </span>
            );
          })}
        </div>
      </div>
    );
  }
}

export default OptionMenuToggle;
